













































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { TableColumnItemType, OperationItemType, OptionItemType } from '../../../types/type'
@Component({
  name: 'myTable',
  components: {
    'empty-container': () => import('../../../components/empty.vue')
  }
})
export default class MyTable extends Vue {
  @Prop({ default: () => [] }) public myTableModuleTitleList: Array<TableColumnItemType>
  @Prop({ default: () => [] }) public myTableModuleBodyList: Array<any>
  @Prop({ default: () => [] }) public columnOperationList: Array<OperationItemType>
  @Prop({ default: 0 }) public nowPage: number

  operationForButton (btnItem: OptionItemType, row: any) {
    this.$emit('operationForButton', btnItem, row)
  }
};
